module.exports = __webpack_public_path__ + "img/icon-star-yellow.ddc7222f.svg";